<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "payload.name") }}</strong>"-->
<!--        content was added by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.contentAdded', {content: $_.get(activity, 'payload.name'), user: $_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ContentAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
